import {find} from '../helpers';

const fade = find('[data-swipe-fade]');
const multiview = find('[data-swipe-multiview]');
const ticker = find('[data-swipe-ticker]');
const testimonials = find('[data-swipe-testimonials]');
const classic = find('[data-swipe-classic]');
const showcase = find('[data-swipe-showcase]');

if (fade) {
    import('./fade');
}

if (multiview) {
    import('./multiview');
}

if (ticker) {
    import('./ticker');
}

if (testimonials) {
    import('./testimonials');
}

if (classic) {
    import('./classic');
}

if (showcase) {
    import('./showcase');
}
